import { differenceInDays } from 'date-fns/differenceInDays';

import { getZonedDate } from '@eika-infrastruktur/date';

import { GRACE_DAYS, MAX_DAY, MIN_DAY } from '../utils/validatePaymentDate';

const useEditLoanPaymentDay = (nextPaymentDate: Date) => {
    const today = getZonedDate();
    const dateDiff = differenceInDays(nextPaymentDate, today);
    if (dateDiff < GRACE_DAYS) {
        const nextPaymentDay = nextPaymentDate.getDate() + 1;
        return {
            targetMinDay: nextPaymentDay,
            isPaymentDateInCurrentMonth: false,
            canChange: nextPaymentDay <= MAX_DAY,
        };
    }

    // Payment next month and more than grace
    if (nextPaymentDate.getMonth() > today.getMonth()) {
        return { targetMinDay: MIN_DAY, isPaymentDateInCurrentMonth: false, canChange: true };
    }

    // Date has not passed
    return { targetMinDay: today.getDate() + 1, isPaymentDateInCurrentMonth: true, canChange: true };
};

export default useEditLoanPaymentDay;
